import ReactJson from '@microlink/react-json-view'
import { useDirectDebitMandates } from 'api/directDebitMandate'
import type { SupportedCountry } from 'api/swagger/definitions/backoffice'
import { useCustomer } from '../api/react-query'
import { usePermissions } from '../contexts/permissions.tsx'
import Spacings from '../figma/tokens/Spacings'
import FigmaBox from '../mynt-components/components/FigmaBox'
import { When } from '../mynt-components/components/When'
import { TextKeys } from '../tiger/libs/TextRepository'
import { CreateDirectDebitMandate } from './DirectDebit'
import { DirectDebitTabAutoGiroApproval } from './DirectDebitTabAutoGiroApproval'
import DirectDebitTabMandateAgreements from './DirectDebitTabMandateAgreements'
import Loader from './Loader'
import TextContainer from './TextContainer'

type DirectDebitTabProps = { customerId: string }

export default function DirectDebitTab({ customerId }: DirectDebitTabProps) {
  const { data: directDebitMandates, isLoading: mandatesIsLoading } = useDirectDebitMandates(customerId)
  const customer = useCustomer(customerId)
  const allowAgreements = usePermissions('customers.direct-debit.agreements.view')
  const allowCreateMandate = usePermissions('customers.direct-debit.mandate.create')

  if (mandatesIsLoading || customer.isLoading) {
    return (
      <FigmaBox fullPadding fullWidth spacing={Spacings.large}>
        <Loader />
      </FigmaBox>
    )
  }

  return (
    <FigmaBox fullWidth direction="column">
      <FigmaBox fullWidth bottom={Spacings.tiny}>
        <TextContainer textKey={TextKeys.directDebitHeading} />
      </FigmaBox>
      <FigmaBox fullWidth direction="row" align="flex-start" justify="space-between" gap={Spacings.medium}>
        <When is={directDebitMandates && allowCreateMandate}>
          <CreateDirectDebitMandate customerId={customerId} country={customer.data?.country as SupportedCountry} />
        </When>
        <When is={allowAgreements}>
          <DirectDebitTabMandateAgreements />
        </When>
        <When is={directDebitMandates?.length !== 0}>
          <FigmaBox
            style={{ display: 'flex', flexBasis: 'fit-content' }}
            direction="column"
            justify="flex-start"
            fullWidth
            gap={Spacings.medium}
          >
            {directDebitMandates?.map((directDebitMandate) => (
              <DirectDebitTabAutoGiroApproval customerId={customerId} mandate={directDebitMandate} key={directDebitMandate.id} />
            ))}
          </FigmaBox>
        </When>
      </FigmaBox>

      <FigmaBox top={Spacings.huge}>
        <ReactJson src={directDebitMandates || {}} collapsed />
      </FigmaBox>
    </FigmaBox>
  )
}
